export class DoctorProfileModel {
  doctorId: number = 0;
  doctorName: string = "";
  doctorPhoneRequired: boolean = false;
  doctorImagePath?: string;

  profileId: number = 0;
  profileName: string = "";
  profileActivity: string = "";
  profileDescription: string = "";

  favourite: boolean = false;
  order: string = "";

  constructor(init?: Partial<DoctorProfileModel>) {
    if (init) Object.assign(this, init);
  }
}
